module.exports = __webpack_public_path__ + "img/other2.fe2b706.png";